import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";
import {
  PASSWORD_RECOVERY_REQUEST,
  passwordRecoverySuccess,
  passwordRecoveryError,
} from "./actions";
import { Env } from "../../env";

function* passwordRecoveryRequest(action) {
  const { email } = action;

  try {
    yield call(axios.post, `${Env.BASE_API_URL}/Accounts/reset`, {
      email,
    });
  } catch (err) {
    let error;
    if (err.response && err.response.status === 404) {
      error = "Utilisateur inconnu.";
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }

    yield put(passwordRecoveryError());
    yield put(flashMessage(error));

    return;
  }

  yield put(passwordRecoverySuccess());
  yield put(push("/login"));
  yield put(
    flashMessage(
      "Veuillez vérifier votre boîte de réception et cliquez sur le lien sécurisé."
    )
  );
}

export default function* watchPasswordRecoveryRequest() {
  yield takeLatest(PASSWORD_RECOVERY_REQUEST, passwordRecoveryRequest);
}



// WEBPACK FOOTER //
// ./src/pages/password-recovery/saga.js